'use client'

import { useLoadMore } from '@/hooks'
import { cn } from '@/lib/utils'
import { useStoreI18n } from '@/store'
import { Typo3SectionSpotHeadlessDownload } from '@/types'
import { Button, CardMedia } from '@/ui/components'
import { memo } from 'react'

interface Props {
  data: Typo3SectionSpotHeadlessDownload
}

const Cards = ({ data }: Props) => {
  const c = data?.content
  const maxItems = data?.appearance?.layout === 'layout-files' ? 9 : 9

  // Hooks
  const { visibleItems, loadMore, hasMore } = useLoadMore(
    c?.media || [],
    maxItems
  )
  //stores
  const D = useStoreI18n.use.dictionary()

  // composers
  const listClass = cn(
    'grid grid-cols-2 gap-xs',
    data.appearance.layout === 'layout-files'
      ? 'md:grid-cols-4'
      : 'md:grid-cols-3 lg:grid-cols-5'
  )

  return (
    <>
      <div className={listClass}>
        {visibleItems.map((item, i) => (
          <CardMedia
            key={i?.toString()}
            image={
              data?.appearance?.layout === 'layout-files'
                ? {
                    publicUrl: item.cropVariants.desktop.publicUrl,
                    properties: item.cropVariants.desktop.properties,
                    isImageSanity: true,
                    isImageCloudinary: false,
                    cropVariants: item.cropVariants
                  }
                : item
            }
            subTitle={
              data?.appearance?.layout === 'layout-files'
                ? item?.properties?.title
                : item?.properties?.alternative
            }
            link={{
              href: item?.publicUrl,
              rel: 'noopener noreferrer',
              target: '_blank'
            }}
          />
        ))}
      </div>
      {hasMore && (
        <div className="mt-lg flex justify-center">
          <Button
            onClick={loadMore}
            size="s"
            aria-label={`Load more items. Currently showing ${visibleItems.length} of ${c?.media?.length || 0} items`}
          >
            {D['fe.plugin.filters.loadMore']}
          </Button>
        </div>
      )}
    </>
  )
}

export default memo(Cards)
